import {useMutation, useQueryClient} from "@tanstack/react-query";
import {toast} from "react-toastify";
import {useDispatch} from "react-redux";
import {setSilent} from "../../../../redux/meta.js";
import {create} from "../../../app/setters/create.js";

export const useWznowienieKp = (setErrors) => {
    const queryClient = useQueryClient();
    const dispatch = useDispatch()

    return useMutation({
        mutationFn: (data) => create(`/oper/rejestr/wznowienie`, data),
        onError: (err) => {
            if (typeof setErrors === 'function') {
                setErrors(err.response?.data?.errors);
            }
            toast.error('Błąd podczas operacji')
        },
        onSuccess: ({message, status}) => {
            dispatch(setSilent(true))
            status === 'success' ? toast.success(message) : toast.error(message)
        },
        onSettled: async () => {
            await queryClient.invalidateQueries({
                predicate: query =>
                    typeof query.queryKey[0] === 'string' &&
                    query.queryKey[0].includes('rejestr/lista'),
            });
        },
    })
}


